import { render, staticRenderFns } from "./CocktailCard.vue?vue&type=template&id=fdc3dd3c&"
import script from "./CocktailCard.vue?vue&type=script&lang=js&"
export * from "./CocktailCard.vue?vue&type=script&lang=js&"
import style0 from "./CocktailCard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports